import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import "../pages/HvalaPasswordPoslanNaMail.scss";
import useTimeout from "../modules/useTimeout";

function HvalaPasswordPoslanNaMail() {
  useTimeout(() => window.location.replace("/"), 3000);
  return (
    <main id="hvala-password-poslan-na-mail">
      <HeaderComponent />
      <Head title="Hvala password poslan na mail" />
      <div className="top-left-hvala-password-poslan-na-mail">
      Password smo Vam poslali na mail.
      </div>
      <div className="top-left-lower-hvala-password-poslan-na-mail">
        Uskoro ćete biti vraćeni na početnu stranicu.
      </div>
    </main>
  );
}

export default HvalaPasswordPoslanNaMail;
